// AI Interview fitness verdict, shared by the student report drawer and the
// standalone AI Interview report. Vocabulary and bands match corporate-react-v2
// (FIT_CHIP) and admin-node's resolveVerdict: 0–39 Not Fit, 40–49 Borderline,
// 50–79 Fit, 80–100 Strong Fit. Framework-free: see aiInterviewVerdict.test.js.

const VERDICT_RANKS = ['Not Fit', 'Borderline', 'Fit', 'Strong Fit']

const NOT_ATTEMPTED = 'Not attempted'

const VERDICT_COLORS = {
  'Strong Fit': { bg: 'rgba(16,185,129,0.12)', fg: '#047857' },
  Fit: { bg: 'rgba(59,130,246,0.10)', fg: '#1d4ed8' },
  Borderline: { bg: 'rgba(245,158,11,0.12)', fg: '#b45309' },
  'Not Fit': { bg: 'rgba(239,68,68,0.12)', fg: '#dc2626' },
  [NOT_ATTEMPTED]: { bg: '#f1f5f9', fg: '#475569' },
}

// Score-anchored ceiling: a stale stored label can lower the verdict but never
// lift it above what the (rounded, as displayed) score supports.
const effectiveVerdict = (score, storedVerdict) => {
  const s = Math.round(Number(score) || 0)
  const ceiling = s < 40 ? 'Not Fit' : s < 50 ? 'Borderline' : s < 80 ? 'Fit' : 'Strong Fit'
  const storedRank = VERDICT_RANKS.indexOf((storedVerdict || '').trim())
  return storedRank === -1 || storedRank > VERDICT_RANKS.indexOf(ceiling)
    ? ceiling
    : VERDICT_RANKS[storedRank]
}

module.exports = { VERDICT_COLORS, NOT_ATTEMPTED, effectiveVerdict }
